import { PROJECT_JOB_COUNT, PROJECT_META } from "utils/query-keys";
import { GITHUB, DISCORD, DRIVE } from "icons";
// context/ProjectContext.js or .tsx
import { createContext, useContext } from "react";
import { fetchProjectBillableCount, fetchProjectMeta, fetchProjectMilestoneCount, fetchProjectJobCount } from "./project/api";

import React from "react";
import useCheckPermissions from "hooks/src/useCheckPermissons";
import { useFetch } from "@/hooks/useFetch";
import { useParams } from "react-router-dom";

export const ProjectContext = createContext(null);

export const useProject = () => {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error("useProjectContext must be used within ProjectProvider");
  }
  return context;
};

// context/ProjectProvider.tsx

export const ProjectProvider = ({ children }) => {
  const { project_slug } = useParams();

  const { canRead: canReadBillables } = useCheckPermissions({
    collection: "billables",
  });

  const { data, isLoading, isError } = useFetch({
    queryKey: ["projects", project_slug],
    queryFn: () => fetchProjectMeta({ project_id: project_slug }),
  });

  const { data: jobCount, isLoading: jobCountLoading } = useFetch({
    queryKey: ["jobs", "count", project_slug],
    queryFn: () => fetchProjectJobCount({ project_id: data?.id }),
    enabled: !!data?.id
  });

  const { data: milestoneCount, isLoading: milestoneCountLoading } = useFetch({
    queryKey: ["milestones", "count", project_slug],
    queryFn: () => fetchProjectMilestoneCount({ project_id: data?.id }),
    enabled: !!data?.id
  });
  const { data: billableCount, isLoading: billableCountLoading } = useFetch({
    queryKey: ["billables", "count", project_slug],
    queryFn: () => fetchProjectBillableCount({ project_id: data?.id }),
    enabled: !!canReadBillables && !!data?.id,
  });


  const contextValue = {
    data,
    isLoading,
    milestoneCount,
    billableCount,
    milestoneCountLoading,
    billableCountLoading,
    isError,
    jobCount,
    jobCountLoading,
    project_slug,
    ...data,
  };

  return (
    <ProjectContext.Provider value={contextValue}>
      {children}
    </ProjectContext.Provider>
  );
};


export const PROJECT_INTEGRATION_TYPES = {
  github: {
    icon: GITHUB,
  },
  discord: {
    icon: DISCORD,
  },
  drive: {
    icon: DRIVE,
  },
};
